import { gql, TypedDocumentNode } from "@apollo/client";

import {
  DeactivateOrgTeamUserMutation,
  DeactivateOrgTeamUserMutationVariables,
} from "./DeactivateUser.generated";

const DEACTIVATE_USER: TypedDocumentNode<
  DeactivateOrgTeamUserMutation,
  DeactivateOrgTeamUserMutationVariables
> = gql`
  mutation deactivateOrgTeamUser($rmTeamUserInput: RmTeamUserInput!) {
    deactivateOrgTeamUser(rmTeamUserInput: $rmTeamUserInput) {
      ok
    }
  }
`;

export default DEACTIVATE_USER;
